// @flow

import * as React from 'react';
import Group from 'sail/Group';
import {ButtonLink} from 'sail/Button';
import type {Article} from 'docs/data';
import {createStripeInternalUrl} from 'docs/util';
import {XRaySidebarSection} from './XRaySidebarSection';

type OwnerProps = {|
  article: Article,
|};

export const Owner = ({article}: OwnerProps) => {
  const owner = article?.xray?.owner;
  if (!owner || !article.xray) {
    return null;
  }

  const link = createStripeInternalUrl('team', {owner});

  return (
    <XRaySidebarSection title="Owner">
      <Group direction="horizontal" alignItems="center" spacing={4}>
        <ButtonLink
          label={owner}
          href={link}
          icon="external"
          iconPosition="right"
          target="_blank"
        />
      </Group>
    </XRaySidebarSection>
  );
};
